module.exports = __webpack_public_path__ + "static/media/doctor2.c9da50e5.jpg";